import { colorConstants } from 'config/colorConstants';
import dayjs from 'dayjs';
import _ from 'lodash';
import { fetchCurrency, formatNumWithKMB } from 'utils/helperMethods';

const nameKey = 'metric_name';
const nameValue = 'metric_value';

// MULTI LINE CHART PARSER
export const priceCurveMultiLineChartParser = (
    data: any[],
    appConfig: any,
    yAxisDropdownData: any,
    metric_type: string,
) => {
    const { priceCurve: priceCurveConfig } = appConfig;
    const currency = fetchCurrency(appConfig) || '';
    try {
        const result: any[] = [];
        const tableData: any[] = [];
        const tableObj: any = {};
        let min = 0;
        let max = 0;
        let xAxisValues: any[] = [];
        data.map((xAxisItem) => {
            const parsedXAxisItem = JSON.parse(xAxisItem);
            const xAxisField = Object.keys(parsedXAxisItem)?.[0];
            const xAxisLabel = Object.keys(parsedXAxisItem[xAxisField]);
            xAxisValues.push(xAxisField);
            xAxisLabel.forEach((item) => {
                const level: any = parsedXAxisItem[xAxisField][item];
                const temp: any = {};
                temp['xAxisData'] = xAxisField;
                temp['type'] = item;
                level.forEach((kpi: any) => {
                    const val = kpi[nameValue]?.[0];
                    const prevVal = kpi[nameValue]?.[1];
                    if (kpi[nameKey] === yAxisDropdownData?.value) {
                        min = Math.min(val, min);
                        max = Math.max(val, max);
                    }

                    temp[kpi[nameKey]] = val === null ? val : _.round(val, 2);
                    temp[`${kpi[nameKey]}_ya`] = prevVal === null ? prevVal : _.round(prevVal, 2);
                });
                result.push(temp);
            });
        });
        result.forEach((item) => {
            if (item?.type in tableObj) {
                tableObj[item?.type]?.push(item);
            } else {
                tableObj[item?.type] = [item];
            }
        });
        for (let i in tableObj) {
            priceCurveConfig.tableHeaders?.forEach((header: any) => {
                const tempObj: any = {};
                tempObj['type'] = header?.label;
                tableObj[i]?.forEach((item: any) => {
                    tempObj['xAxis'] = i;
                    tempObj[item['xAxisData'] + ' '] = { pre: currency, post: '', value: item[header?.key] };
                });
                tableData.push(tempObj);
            });
            //adding extra items in table
            if (metric_type === 'per_eq') {
                const volumeItems = [
                    { key: 'sales', label: 'Volume Sales' },
                    { key: 'sales_ya', label: 'Volume Sales YA' },
                ];
                volumeItems?.forEach((volItem) => {
                    let dynamicTableRows: any = {};
                    dynamicTableRows['type'] = volItem?.label;
                    dynamicTableRows['xAxis'] = i;
                    tableObj[i]?.forEach((item: any) => {
                        dynamicTableRows['xAxis'] = i;
                        dynamicTableRows[item['xAxisData'] + ' '] = { pre: '', post: '', value: item[volItem?.key] };
                    });
                    tableData.push(dynamicTableRows);
                });
            } else {
                const unitItems = [
                    { key: 'sales', label: 'Unit Sales' },
                    { key: 'sales_ya', label: 'Unit Sales YA' },
                ];
                unitItems?.forEach((unitItem) => {
                    let dynamicTableRows: any = {};
                    dynamicTableRows['type'] = unitItem?.label;
                    dynamicTableRows['xAxis'] = i;
                    tableObj[i]?.forEach((item: any) => {
                        dynamicTableRows['xAxis'] = i;
                        dynamicTableRows[item['xAxisData'] + ' '] = { pre: '', post: '', value: item[unitItem?.key] };
                    });
                    tableData.push(dynamicTableRows);
                });
            }
        }
        return { result, min, max, xAxisValues, tableData };
    } catch (error) {
        throw error;
    }
};

export const priceCurveMultiLineTableParser = (data: any[], config: any) => {
    try {
        const result: any[] = [];
    } catch (error) {
        throw error;
    }
};

//SALES TREND CHART PARSER
export const salesTrendChartParser = (data: any[], appConfig: any) => {
    try {
        const lineChartResult: any = { minVal: 0, maxVal: 0, data: [] };
        data.forEach((item: any, index: number) => {
            lineChartResult.minVal = Math.min(
                lineChartResult?.minVal,
                item?.currentValue || 0,
                item?.previousValue || 0,
            );
            lineChartResult.maxVal = Math.max(
                lineChartResult?.maxVal,
                item?.currentValue || 0,
                item?.previousValue || 0,
            );
            const lineChartTempObj = {
                period: dayjs(item?.startTimestamp).format(appConfig?.commonConfig?.dateFormatAlt),
                // period: item?.periodLabel,
                'Current Year': item?.currentValue,
                'Year Ago': item?.previousValue,
            };

            lineChartResult?.data?.push(lineChartTempObj);
        });
        return lineChartResult;
    } catch (error) {
        throw error;
    }
};
